import { configureStore } from '@reduxjs/toolkit'


import { useDispatch } from "react-redux";
import  userReducer from '../redux/reducers/userReducer/index';
import urlReducer from './reducers/urlReducer';

export const store = configureStore({
  reducer: {
    userReducer: userReducer,
    urlReducer: urlReducer
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()